__turbopack_context__.v({
  "default": "gallery-module-scss-module__e1QtSW__default",
  "image": "gallery-module-scss-module__e1QtSW__image",
  "lightboxImage": "gallery-module-scss-module__e1QtSW__lightboxImage",
  "photos": "gallery-module-scss-module__e1QtSW__photos",
  "thumbnail": "gallery-module-scss-module__e1QtSW__thumbnail",
  "withPadding": "gallery-module-scss-module__e1QtSW__withPadding",
});
